import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { Icon } from '../../icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FormCounter = function FormCounter(_ref) {
  var label = _ref.label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      min = _ref.min,
      max = _ref.max,
      onChange = _ref.onChange;
  var onIncrement = useCallback(function () {
    if (max !== undefined && value >= max) return;
    onChange(value + 1);
  }, [max, onChange, value]);
  var onDecrement = useCallback(function () {
    if (min !== undefined && value <= min) return;
    onChange(value - 1);
  }, [min, onChange, value]);
  var disableIncrement = useMemo(function () {
    return max !== undefined && value >= max;
  }, [max, value]);
  var disableDecrement = useMemo(function () {
    return min !== undefined && value <= min;
  }, [min, value]);
  return /*#__PURE__*/_jsxs("div", {
    id: "number-input",
    "aria-label": "number-input",
    className: styles.inputContainer,
    children: [label && /*#__PURE__*/_jsx("span", {
      className: styles.label,
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.inputGroup,
      children: [/*#__PURE__*/_jsx("button", {
        type: "button",
        "aria-label": "decrement",
        onClick: onDecrement,
        className: classNames(styles.button, _defineProperty({}, styles.disabledButton, disableDecrement)),
        disabled: disableDecrement,
        children: /*#__PURE__*/_jsx(Icon, {
          name: "minus",
          width: 16,
          height: 16
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.value,
        children: value
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        "aria-label": "increment",
        onClick: onIncrement,
        className: classNames(styles.button, _defineProperty({}, styles.disabledButton, disableIncrement)),
        disabled: disableIncrement,
        children: /*#__PURE__*/_jsx(Icon, {
          name: "plus",
          width: 16,
          height: 16
        })
      })]
    })]
  });
};